import React from 'react';
import Navbar from '../components/layout/navbar/Navbar';
import Footer from '../components/layout/footer/Footer';
import ProjectsGreeting from '../components/layout/projects/ProjectsGreeting';

const Projects = () => {
  return (
    <div>
      <Navbar />
      <ProjectsGreeting />
      <Footer />
    </div>
  );
};

export default Projects;
